import React, { Component } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import OwlCarousel from 'react-owl-carousel2';
import Heading from "../../elements/Heading";
import animations from "./animations";
import CareerBenefits from "../CareerBenefits";

class Careers extends Component {

    constructor(props) {
        super(props);

        this.sceneController = null;
        this.state = {
            careers: [],
            benefits: [],
            mobileCareers: []
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({
                careers: this.props.data.careers,
                benefits: this.props.data.benefits,
                mobileCareers: [this.props.data.leadCopy, ...this.props.data.careers]
            });
            this.sceneController = animations.initialise(this);
        }
    }

    componentWillUnmount() {
        animations.destroy(this.sceneController);
    }

    setTitleRef(el) {
        this.titleRef = el;
    }

    setSubTitleRef(el) {
        this.subTitleRef = el;
    }

    render() {
        const Desktop = this.state.careers.map((item, key) => {
            return (
                <li key={key}>{item}</li>
            );
        });

        const Mobile = this.state.mobileCareers.map((item, key) => {
            return (
                <div key={key}>{item}</div>
            );
        });

        const Benefits = this.state.benefits.map((benefit, key) => {
            return (
                <CareerBenefits key={key} title={benefit.title} value={benefit.value} />
            );
        });

        const options = {
            items: 1,
            loop: true,
            autoHeight: false,
            autoplay: false
        };

        return (
            <section className="careers">
                <div className="row heading">
                    <div className="col-md-8 col-md-offset-2 col-xs-12 text-sm-center text-xs-center">
                        <Heading
                            title={this.props.data.title}
                            subTitle={this.props.data.subTitle}
                            setTitleRef={this.setTitleRef.bind(this)}
                            setSubTitleRef={this.setSubTitleRef.bind(this)}
                        />
                        <p className="desktop">{this.props.data.leadCopy}</p>
                    </div>
                </div>

                <BrowserView>
                    <div className="row desktop">
                        <div className="col-md-8 col-md-offset-2 col-xs-12 text-sm-center text-xs-center">
                            <ul className="core-values">
                                {Desktop}
                            </ul>
                        </div>
                    </div>
                    <div className="benefits-trigger" />
                    <div className="row benefits desktop">
                        <div className="col-md-8 col-md-offset-2 col-xs-12 centered">
                            <h4>{this.props.data.heading2}</h4>
                            <div className="row">
                                <div className="benefits-inner">
                                    {Benefits}
                                </div>
                            </div>
                        </div>
                    </div>
                </BrowserView>

                <MobileView>
                    <div className="row mobile">
                        <div className="col-xs-12 centered">
                            {this.state.mobileCareers.length > 0 ?
                                <OwlCarousel options={options}>
                                    {Mobile}
                                </OwlCarousel>
                            : ''}
                        </div>
                    </div>
                </MobileView>
            </section>
        );   
    }
    
}

export default Careers;


// WEBPACK FOOTER //
// ./resources/assets/js/homepage/Careers/Careers.js